import { useApolloClient } from "@apollo/client";
import { useCallback, useState } from "react";
import { getAssetPersist } from "src/api/asset-persist/stores/useAssetPersist";
import DeleteGatheringDocument from "src/api/graphql/__generated__/documents/DeleteGatheringDocument";
import { DeleteGatheringInput } from "src/api/graphql/__generated__/graphql";
import evictGathering from "src/api/graphql/evictGathering";
import { useAsyncMutation } from "src/api/graphql/helper";
import log from "src/helpers/log";
import toastError from "src/helpers/toastError";

const useDeleteGathering = () => {
	const [loading, setLoading] = useState(false);
	const deleteGatheringMutation = useAsyncMutation(DeleteGatheringDocument);
	const apolloClient = useApolloClient();

	const handleDeleteGathering = useCallback(
		async (input: DeleteGatheringInput) => {
			setLoading(true);
			try {
				const { gatheringId, deleteOwnPhotos } = input;
				if (deleteOwnPhotos) {
					const { filterUploadAssets } = getAssetPersist();
					filterUploadAssets((image) => image.gatheringId !== gatheringId);
				}

				await deleteGatheringMutation({
					input,
				});
				evictGathering(apolloClient.cache, gatheringId, {
					delay: 300,
				});
				return {
					success: true,
				};
			} catch (err) {
				toastError();
				log.error({ err }, "Failed to delete gathering");
				return {
					success: false,
				};
			} finally {
				setLoading(false);
			}
		},
		[apolloClient, deleteGatheringMutation],
	);

	return {
		loading,
		handleDeleteGathering,
	};
};
export default useDeleteGathering;
